<template>
  <div style="height:100vh;background:#fff;overflow:scroll;overflow-x:hidden">

  
 
 <div v-if='!loadstatus' style="z-index:100000000000000;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.3)" class="d-flex align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="../assets/loader.gif" class="img-fluid" style="width:100%">
   </div>
 </div>
 
  
 
 
 
<div class="header py-md-5 pt-md-0 pt-3 ">
 <div class="container py-1 "  >
      <div  style="padding:0px;margin:0px">





  <header id="header" class="header" role="banner" style="padding:0px">
    
    <div class="inner" style="padding:0px;width:100%;max-width:100%">
           <div class="logo">
            <a href='https://websitelearners.com/'  style="text-decoration:none!important;">
                    <img src="https://websitelearners.com/content/uploads/2016/09/logo.svg" alt="Website Learners" width="275" height="42" />
                  </a>
      </div>
            <div class="logo mob">
             <a href='https://websitelearners.com/'  style="text-decoration:none!important;">
                    <img src="https://websitelearners.com/content/uploads/2016/09/logo-mobile.svg" alt="Website Learners" width="40" height="42" />
                  </a>
      </div>

      
          <!--<div class="tutor_menu">
            <a href="/cart" class="cart_link">
              <img src="">
              <span class="cart_count" id="cartCount"></span>
            </a>
                        <a href="/dashboard" class="account_link">
                          </a>
                      </div>-->
        

            <button class="navigate"><span class="navigate-inner"></span></button>
                  <nav class="main-nav" style="flex:1">
        <div class="nav-left">
          <div class="logo mob">
               <router-link to='https://websitelearners.com/' >
                            <img src="https://websitelearners.com/content/uploads/2016/09/logo-mobile.svg" alt="Website Learners" width="40" height="42" />
                         </router-link>
          </div>
          <i class="close icon-close"></i>
        </div>

        <ul id="menu-header-menu" class="menu"><li id="menu-item-23569" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-23569"><a href="https://websitelearners.com/courses/">Course</a></li>

<li id="menu-item-25101" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-25101 "><a href="https://shop.websitelearners.com">Shop</a>

 
</li>

<li id="menu-item-25102" class="sub-menu-columns menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-25102"><a href="#">Tools</a>
<ul class="sub-menu">
  <li id="menu-item-25103" class="sub-menu-column menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-25103"><a href="#">Guides</a>
  <ul class="sub-menu">
    <li id="menu-item-16704" class="menu-item menu-item-type-post_type menu-item-object-resource menu-item-16704"><a href="https://websitelearners.com/video/make-a-website/">Start a Website</a></li>
    <li id="menu-item-16705" class="menu-item menu-item-type-post_type menu-item-object-resource menu-item-16705"><a href="https://websitelearners.com/video/make-a-blog/">Start a Blog</a></li>
    <li id="menu-item-16706" class="menu-item menu-item-type-post_type menu-item-object-resource menu-item-16706"><a href="https://websitelearners.com/video/make-an-ecommerce-website/">E-Commerce Website</a></li>
    <li id="menu-item-16707" class="menu-item menu-item-type-post_type menu-item-object-resource menu-item-16707"><a href="https://websitelearners.com/video/how-to-make-a-divi-website/">Divi Theme Website</a></li>
    <li id="menu-item-24317" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-24317"><a href="https://websitelearners.com/video/make-a-wordpress-website/">WordPress Site</a></li>
  </ul>
</li>
  <li id="menu-item-25104" class="sub-menu-column menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-25104"><a href="#">Tools</a>
  <ul class="sub-menu">
    <li id="menu-item-8935" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-8935"><a href="https://websitelearners.com/tools/">Tools we Recommend</a></li>
    <li id="menu-item-65" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-65"><a href="https://websitelearners.com/themes/">Themes for WordPress</a></li>
    <li id="menu-item-14928" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-14928"><a href="https://websitelearners.com/wordpress-hosting/">Hosting for WordPress</a></li>
    <li id="menu-item-17399" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17399"><a href="https://websitelearners.com/domain-checker/">Find your Domain</a></li>
    <li id="menu-item-24990" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-24990"><a href="https://websitelearners.com/hosting-finder/">Hosting finder</a></li>
    <li id="menu-item-23880" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-23880"><a href="/ebooks">Ebooks</a></li>
  </ul>
</li>
  <li id="menu-item-25106" class="sub-menu-column products-sub-menu menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-25106"><a href="#">Products</a>
  <ul class="sub-menu">
     <li id="menu-item-25107" class="product-sub-menu menu-item menu-item-type-custom menu-item-object-custom menu-item-25107">
 
      <a href="https://webspacekit.com/">WebSpaceKit</a><span class="description">Get the Fastest WordPress Hosting along with free domain.</span></li>

 
<li style="height: auto!important;" id="menu-item-25107" class="product-sub-menu menu-item menu-item-type-custom menu-item-object-custom menu-item-25107">
 
      <a href="https://makeyourwp.com/">MakeYourWP</a><span class="description">Want to build a website fast? Check out these Ready Made WordPress Websites.</span></li>


      <!--
    <li id="menu-item-25108" class="product-sub-menu menu-item menu-item-type-custom menu-item-object-custom menu-item-25108"><a href="https://makeyourwp.com/"><img src="https://firebasestorage.googleapis.com/v0/b/wl-shopping.appspot.com/o/images%2Fmywp_lcon.png?alt=media&token=dd0db4e6-6670-4042-aed9-973dcc9e2546"> <br>MakeYourWP</a><span class="description">It is a long established fact page when looking at its layout.</span></li>

  -->
  </ul>
</li>
</ul>
</li>
<li id="menu-item-23879" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-23879"><a href="https://websitelearners.com/blog/">Blog</a></li>
<li id="menu-item-25105" class="sub-menu-columns-2 menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-25105"><a href="#">Company</a>
<ul class="sub-menu">
  <li id="menu-item-23570" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-23570"><a href="https://websitelearners.com/about/">About</a></li>
  <li id="menu-item-3008" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-3008"><a href="https://websitelearners.com/careers/">Careers</a></li>
  <li id="menu-item-61" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-61">
      <a  style="text-decoration:none!important" href="https://websitelearners.com/contact-us/">
       Contact 
                </a>
  </li>
</ul>
</li>
</ul>
        <div class="nav-right">
        



 
                
              
                  
     




 
                  
        </div>
      </nav>
                </div>
  </header>
</div>
</div>
</div>




<div style=" margin-top:100px">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <div style="border-radius:5px; ">
          <h3 style="font-size:18px;margin-bottom:20px">Paste the paragraph here</h3>
          <div style="height:440px">
            <textarea style="width:100%;height:100%;padding:20px" v-model='paragraph' class="form-control"></textarea>
          </div>
          <button v-on:click='change' style=" color:#fff;padding:10px 20px;margin:20px 0px" class="searchbtn" >Translate</button>
        </div>
      </div>

      <div class="col-md-6">
        <div style="border-radius:5px; ">
          <h3 style="font-size:18px;margin-bottom:20px">Translated Paragraph</h3>
          <div style="height:440px">
            <textarea style="width:100%;height:100%;padding:20px" v-model='result' class="form-control"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
   
 
   
</div>

 
 
<div class="" style="background:#F9FBFE;padding:50px 0;margin-top:50px">
  <div class="container">
    <div class="row">
      <div class="col-md-4">
        <div>
          <div>
            <router-link to='/'>
            <img src="https://websitelearners.com/app/uploads/2016/09/logo.svg" style="width:200px" class="img-fluid">
          </router-link>
          </div>
          <p style="color:#98A5B6;font-size:18px;font-weight:400;margin:35px 0"    >2021 © All rights reserved.</p>
          <div  class="d-flex align-items-center    ">
            <a href="http://fb.me/websitelearners" style="display:block;text-decoration:none;cursor:pointer;min-width:40px;width:40px;height:40px;background:#fff;box-shadow:0 0 20px rgba(0,0,0,0.1);border-radius:50%" class="d-flex align-items-center justify-content-center mr-3 socialbox">
              <i class='bx bxl-facebook-circle' style="color:#3C5998;font-size:23px;"></i>
            </a>
             <a href="https://twitter.com/websitelearners" style="display:block;text-decoration:none;cursor:pointer;min-width:40px;width:40px;height:40px;background:#fff;box-shadow:0 0 20px rgba(0,0,0,0.1);border-radius:50%" class="d-flex align-items-center justify-content-center mr-3 socialbox">
               <i class='bx bxl-twitter' style="color:#39A2F2;font-size:23px;"></i>
            </a>
               <a href="https://www.youtube.com/channel/UCpWT_QfKk7BJIpn709YgsYA" style="display:block;text-decoration:none;cursor:pointer;min-width:40px;width:40px;height:40px;background:#fff;box-shadow:0 0 20px rgba(0,0,0,0.1);border-radius:50%" class="d-flex align-items-center justify-content-center mr-3 socialbox">
              <i class='bx bxl-youtube' style="color:#ED3833;font-size:23px;"></i>
            </a>
               <a href="https://www.instagram.com/websitelearners/" style="display:block;text-decoration:none;cursor:pointer;min-width:40px;width:40px;height:40px;background:#fff;box-shadow:0 0 20px rgba(0,0,0,0.1);border-radius:50%" class="d-flex align-items-center justify-content-center mr-3 socialbox">
              <i class='bx bxl-instagram' style="color:#E13B6C;font-size:23px;"></i>
            </a>
               <a href="https://in.linkedin.com/company/website-learners" style="display:block;text-decoration:none;cursor:pointer;min-width:40px;width:40px;height:40px;background:#fff;box-shadow:0 0 20px rgba(0,0,0,0.1);border-radius:50%" class="d-flex align-items-center justify-content-center mr-3 socialbox">
              <i class='bx bxl-linkedin-square' style="color:#1B43EF;font-size:23px;"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-8" style="padding:0;margin:0">

        <div class="container" style="padding:0;margin:0">
          <div class="row" style="padding:0;margin:0">
              <div class="col-md-4" style="padding:0;margin:0">
        <div class="p-md-0 p-3 mt-md-0 mt-3 txthead">
          <h3 style="color:#3A446B;font-size:20px;font-weight:600;margin-bottom:30px">Resources</h3>
          <p style="color:#8392A7;font-size:17px;margin-top:17px"><a style="color:#8392A7" href='https://websitelearners.com/tools/'>Tools we recommend</a></p>
          <p style="color:#8392A7;font-size:17px;margin-top:17px"><a style="color:#8392A7" href='https://websitelearners.com/about/'>About Us</a></p>
          <p style="color:#8392A7;font-size:17px;margin-top:17px"><a style="color:#8392A7" href='https://websitelearners.com/careers/'>Careers @ WL</a></p>
          <p style="color:#8392A7;font-size:17px;margin-top:17px"><a style="color:#8392A7" href='https://websitelearners.com/terms-of-service/'>Terms of Service</a></p>
          <p style="color:#8392A7;font-size:17px;margin-top:17px"><a style="color:#8392A7" href='https://websitelearners.com/privacy-policy/'>Privacy Policy</a></p>
        </div>
      </div>
       <div class="col-md-4" style="padding:0;margin:0">
        <div class="p-md-0 p-3 txthead">
          <h3 style="color:#3A446B;font-size:20px;font-weight:600;margin-bottom:30px">Website Build Guides</h3>
          <p style="color:#8392A7;font-size:17px;margin-top:17px"><a style="color:#8392A7" href='https://websitelearners.com/make-a-website/'>Making a Website</a></p>
          <p style="color:#8392A7;font-size:17px;margin-top:17px"><a style="color:#8392A7" href='https://websitelearners.com/make-a-blog/'>Make a Blog</a></p>
          <p style="color:#8392A7;font-size:17px;margin-top:17px"><a style="color:#8392A7" href='https://websitelearners.com/make-ecommerce-website-india/'>E-Commerce Website</a></p>
          <p style="color:#8392A7;font-size:17px;margin-top:17px"><a style="color:#8392A7" href='https://websitelearners.com/how-to-make-a-divi-website/'>Making a Divi Website</a></p>
           
        </div>
      </div>
       <div class="col-md-4" style="padding:0;margin:0">
        <div class="p-md-0 p-3 txthead">
          <h3 style="color:#3A446B;font-size:20px;font-weight:600;margin-bottom:30px">From the Blog</h3>
            <p style="color:#8392A7;font-size:15px;margin-top:17px">
            <a href="https://websitelearners.com/web-space-kit-review/" style="color:#53BA90">Web Space Kit Review – Is this the Best Hosting provider for your website?</a>
          </p>
          <p style="color:#8392A7;font-size:15px;margin-top:17px">
             <a href="https://websitelearners.com/how-to-create-a-wordpress-website/" style="color:#53BA90">How to Create a WordPress website in 2021 – A Step-by-Step Guide for Beginners</a>
          </p>
          <p style="color:#8392A7;font-size:15px;margin-top:17px">
                         <a href="https://websitelearners.com/how-to-make-your-website-responsive/" style="color:#53BA90">How to Make Your Website Responsive in 2021</a>

          </p>
        </div>
      </div>
          </div>
        </div>
        
      </div>
    
    </div>
  </div>
</div>

   </div>


</template>

<script>
  const fb = require('../firebase/firebaseconfig.js')
import firebase from 'firebase'
 

 import axios from 'axios'
export default {
 
      
  data () {

        return{
            directory:{
               
               
            },
            loadstatus:false,
            arraydirectory:['banaa','pahle','paaoge'],
            result:'',
            paragraph:''
        }
     
    
  },
  created(){
   var vm=this

  fb.db.collection("dictionary").onSnapshot(querySnapshot=>{
 var  x={},arrr=[]
        querySnapshot.forEach((doc) => {
            
            console.log(doc.id, " => ", doc.data());

            x[doc.data().name]=doc.data().value
            arrr.push(doc.data().name)



        });
       

        vm.directory={
          ...x
        }
        vm.arraydirectory=[
        ...arrr
        ]

        vm.loadstatus=true


})



 
  },
    methods:{ 

      change(){
 console.log(this.paragraph)
var x= this.paragraph.replace(/(\r\n|\n|\r)/gm, " ");

console.log(x)
        var paragarphs=x.split(' ')
console.log(paragarphs)
        var actpara=this.paragraph
        for(var i=0;i<paragarphs.length;i++){
          
          if(this.arraydirectory.includes(paragarphs[i])){

            var index=this.arraydirectory.indexOf(paragarphs[i]) 
             
            actpara=actpara.replace(paragarphs[i] , this.directory[this.arraydirectory[index]]); 
          }
        }
        
        this.result=actpara


      }
 
  },
 

   mounted(){ 

 
   (function(w, d, $) {

 


$('li.menu-item-has-children > a').on("click touch", function(e) {
 

        e.preventDefault();
        if($(w).width() <= 768) {


          $('.sub-menu').css('min-width', $(w).width());
          $('.sub-menu-column .sub-menu').css('min-width', '0px');
          $('.products-sub-menu .sub-menu').css('min-width', $(w).width()-50);
          if( $(this).hasClass('on') ) {
            if($(this).parent().hasClass('sub-menu-columns')){
              $(this).next('.sub-menu').slideUp(350);
              $(this).removeClass('on');
            } else if($(this).parent().hasClass('sub-menu-column')){
              $(this).next('.sub-menu').slideUp(350).delay(150).queue(function (next) {
                $(this).parent('.sub-menu-column').css('height', 'auto');
                next();
              });
              $(this).removeClass("on");
            } else if($(this).parent('li.menu-item-has-children').hasClass('login-menu')) {
              $(this).next('.sub-menu').slideUp(350);
              $(this).removeClass('on');
              $(this).parents('.nav-right').css('background-color', '#FFF');
            } else {
              $(this).next('.sub-menu').slideUp(350);
              $(this).removeClass('on');
            }
          }
          else {
            if($(this).parent().hasClass('sub-menu-columns')){
              $("li.menu-item-has-children > a").not($(this)).next('.sub-menu').slideUp(350).delay(350).queue(function (next) {
                $('.sub-menu-column').css('height', 'auto');
                next();
              });
              $("li.menu-item-has-children > a").not($(this)).removeClass("on");
              $(this).next('.sub-menu').slideDown(350);
              $(this).addClass('on');
            } else if($(this).parent().hasClass('sub-menu-column')){
              let submenuHeight1 = $(this).next('.sub-menu').height();
              $(this).parent('.sub-menu-column').css('height', 63+submenuHeight1);
              $(this).next('.sub-menu').slideDown(350);
              $(this).addClass('on');
            } else if($(this).parent('li.menu-item-has-children').hasClass('login-menu')) {
              $(this).parents('.nav-right').css('background-color', '#F9FCFC');
              $("li.menu-item-has-children > a").not($(this)).next('.sub-menu').slideUp(350).delay(350).queue(function (next) {
                $('.sub-menu-column').css('height', 'auto');
                next();
              });
              $("li.menu-item-has-children > a").not($(this)).removeClass("on");
              $(this).next('.sub-menu').slideDown(350);
              $(this).addClass('on');
            } else {
              $("li.menu-item-has-children > a").not($(this)).next('.sub-menu').slideUp(350).delay(350).queue(function (next) {
                $('.sub-menu-column').css('height', 'auto');
                next();
              });
              $("li.menu-item-has-children > a").not($(this)).removeClass("on");
              $(this).next('.sub-menu').slideDown(350);
              $(this).addClass('on');
            }
          }
        }
      });



var toggleClose = $('.close'),
menuWrapper = $('.main-nav'),
          bodyControl     = $('body'),
          mouse_is_inside = false;


      $('.navigate').click( function() {

   
        bodyControl.removeClass("active");
        menuWrapper.addClass("active");
        bodyControl.addClass("active");
        return false;
      });


      toggleClose.click( function() {
        bodyControl.removeClass("active");
        menuWrapper.removeClass("active");
        return false;
      });

      })(window, document, jQuery);


} 
   ,
  computed:
  { 

  

  },

   

   
   
    
 
  
}
</script>
<style scoped >
 

</style>
 



// WEBPACK FOOTER //
// src/components/translator.vue